import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    Typography,
    List,
    ListItem,
    ListItemText,
    CircularProgress,
    TextField,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Box,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

const Tests = () => {
    const [tests, setTests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [search, setSearch] = useState('');
    const [editingCategory, setEditingCategory] = useState(null);
    const [newCategoryName, setNewCategoryName] = useState('');

    useEffect(() => {
        fetchTests();
    }, [search]);

    const fetchTests = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/tests`, {
                params: { search },
            });
            setTests(response.data.items || []); // Ensure tests is always an array
            setLoading(false);
        } catch (error) {
            console.error('Error fetching tests:', error);
            setError('An error occurred while fetching tests. Please try again later.');
            setLoading(false);
        }
    };

    const handleEditCategory = (category) => {
        setEditingCategory(category);
        setNewCategoryName(category.name);
    };

    const handleUpdateCategory = async () => {
        try {
            await axios.put(`${process.env.REACT_APP_API_URL}/api/tests/${editingCategory._id}`, {
                name: newCategoryName,
            });
            setEditingCategory(null);
            fetchTests();
        } catch (error) {
            console.error('Error updating category:', error);
            setError('An error occurred while updating the category. Please try again.');
        }
    };

    if (loading) return <CircularProgress />;
    if (error) return <Typography color="error">{error}</Typography>;

    return (
        <Box sx={{ maxWidth: 800, margin: 'auto', padding: 2 }}>
            <Typography variant="h4" gutterBottom>
                Manage Tests
            </Typography>
            <TextField
                fullWidth
                label="Search tests"
                variant="outlined"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                margin="normal"
            />
            <List>
                {tests.map((test) => (
                    <ListItem key={test._id}>
                        <ListItemText primary={test.name} secondary={`Number of questions: ${test.questionCount}`} />
                        <IconButton onClick={() => handleEditCategory(test)}>
                            <EditIcon />
                        </IconButton>
                    </ListItem>
                ))}
            </List>
            <Dialog open={!!editingCategory} onClose={() => setEditingCategory(null)}>
                <DialogTitle>Edit Test Name</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="New Test Name"
                        fullWidth
                        value={newCategoryName}
                        onChange={(e) => setNewCategoryName(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setEditingCategory(null)}>Cancel</Button>
                    <Button onClick={handleUpdateCategory}>Update</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default Tests;
